    let user_approval = [
          { id: "ar", name: "Approver Role" },
          { id: "lm", name: "Line Manager" },          
          { id: "nr", name: "Not required (Auto-approve)" },          
          { id: "su", name: "Specific User" }          
        ]
    
    module.exports = user_approval
    
    